import 'core-js/stable/array/from';
import 'core-js/stable/url-search-params';

import Cookies from 'js-cookie';

import CurrencySwitcher from '../../../currency_switcher';

class PaymentButton {
	constructor(button) {
		this.button = button;
		this.gateway = this.button.dataset.for;

		this.button.addEventListener('click', () => {
			const confirm = this.button.dataset.confirm;
			if (confirm && !window.confirm(confirm)) {
				return;
			}

			this.button.disabled = true;

			this.form.querySelector('input[name="session_key"]').value =
				Cookies.get('session_key');

			this.fetch().then(json => this.after_response(json));
		});
	}

	get form() {
		return this.button.form;
	}

	fetch() {
		return fetch(this.url(), {
			method: 'POST',
			credentials: 'same-origin',
			body: new FormData(this.form)
		}).then(response => {
			if (response.status == 401) {
				window.location.reload();
				return;
			}

			return response.json();
		});
	}

	url() {
		return `/api/v2/payments/${this.gateway}/create`;
	}

	after_response(json) {
		if (this.form.analytics) {
			this.form.analytics.send(() => {
				window.location.href = json.data.redirect_url;
			});
		} else {
			window.location.href = json.data.redirect_url;
		}
	}
}

class SolidPaymentButton extends PaymentButton {
	constructor(button) {
		super(button);
	}

	after_response(json) {
		// eslint-disable-next-line no-undef
		const form = PaymentFormSdk.init(json.data);
		let paid_param = null;
		const context = this;

		const solidForm = document.getElementById('solidForm');
		solidForm.querySelector('.close').onclick = function() {
			solidForm.classList.remove('shown');
			if (paid_param) {
				context.redirect_with_paid_param(
					paid_param, json.data.redirect_url
				);
			}
		};

		form.on('mounted', e => {
			if (e.data.entity !== 'form') return;
			solidForm.classList.add('shown');
			this.button.disabled = false;
			if (this.form.analytics) this.form.analytics.send();
		});

		// Redirect to the request with a "successful payment" message on success
		form.on('success', () => {
			paid_param = 'true';
			context.hide_solid_payment_buttons(solidForm);
		});

		// Redirect to the request with a "failed payment" message on fail
		form.on('fail', () => {
			paid_param = 'false';
			context.hide_solid_payment_buttons(solidForm);
		});

		// In case of an unexpected error (invalid form data)
		// we show the user an "unexpected error" message and send
		// the error to Sentry
		form.on('error', ({ data }) => {
			// Show the error
			solidForm.querySelector('.error').classList.remove('hidden');
			solidForm.classList.add('shown');

			// Redirect to request with "failed payment" message on closing the modal
			solidForm.querySelector('.close')
				.addEventListener('click', () => {
					context.redirect_with_paid_param(
						'false', window.location.href
					);
				});

			// Capture the error and send it to our Sentry
			const paymentId = json.data.payment_data.order_id;
			// eslint-disable-next-line no-undef
			Raven.captureMessage(
				`Solid payment form error for payment ${paymentId}`, {
					level: 'error',
					logger: 'payment_errors',
					extra: {
						errors: [data.value],
						data: json.data.payment_data,
						payment_id: paymentId
					}
				}
			);
		});
	}

	redirect_with_paid_param(param_value, redirect_url) {
		const query = new URLSearchParams(window.location.search);
		query.append('paid', param_value);
		const url = new URL(redirect_url);
		url.search = query;
		window.location.href = url;
	}

	// This is needed because Solid payment buttons remain visible after payment
	hide_solid_payment_buttons(form) {
		form.querySelector('#payment-buttons').classList.add('hidden');
	}
}

class PlatronPaymentButton extends PaymentButton {
	constructor(button) {
		 super(button);
	}
}

class StripePaymentButton extends PaymentButton {
	constructor(button) {
		super(button);
	}
}

class InvoicePaymentButton extends PaymentButton {
	constructor(button) {
		super(button);
	}

	url() {
		return '/api/v2/payments/invoices/create';
	}
}

class CashPaymentButton extends PaymentButton {
	constructor(button) {
		super(button);
	}

	url() {
		return '/api/v2/payments/cash/create';
	}
}

class Payment {
	static get Offer() {
		return this._Offer || (
			this._Offer = class {
				constructor(container) {
					this.container = container;
					this.dataset = this.container.dataset;
					this.id = this.dataset.id;
					this.book_buttons = this.container.querySelectorAll('button.book');
					this.back_buttons = this.container.querySelectorAll('button.back');
					if (this.book_buttons.length == 0) return;

					this.pay_buttons = container.querySelector('.pay_buttons');
					this.payment_gateways = container.querySelector('.payment_gateways');
					this.amounts = this.payment_gateways.querySelector('.amounts');
					this.amount_inputs =
						this.payment_gateways.querySelectorAll('input[name="amount"]');
					this.gateways = this.payment_gateways.querySelector('.gateways');
					this.gateways.querySelectorAll('input').forEach(item => {
						item.addEventListener('change', event => {
							this.amount_inputs.forEach(input => {
								input.closest('li').classList.toggle(
									'hidden',
									!item.closest('li').classList
										.contains(input.dataset.for)
								);
							});
							const first_input =
								Array
									.from(this.amount_inputs)
									.find(element => {
										const visible =
											!element
												.closest('li')
												.classList
												.contains('hidden');
										return visible;
									});
							first_input.checked = true;
							first_input.dispatchEvent(new Event('change'));
							this
								.pay_buttons
								.querySelectorAll('button')
								.forEach(button => {
									button.classList.toggle(
										'hidden',
										!item.closest('li').classList
											.contains(button.dataset.for)
									);
								});
						});
					});

					this.amount_inputs.forEach(input => {
						input.addEventListener('change', event => {
							input.nextElementSibling.nextElementSibling.checked = true;
						});
					});

					// Initialize pay buttons

					this.pay_buttons.querySelectorAll('button').forEach(item => {
						switch (item.dataset.for) {
							case 'solid':
								new SolidPaymentButton(item);
								break;
							case 'stripe':
								new StripePaymentButton(item);
								break;
							case 'platron':
								new PlatronPaymentButton(item);
								break;
							case 'invoice':
								new InvoicePaymentButton(item);
								break;
							case 'cash':
								new CashPaymentButton(item);
								break;
							default:
								null;
						}
					});

				}

				hide() {
					this.container.classList.add('hidden');

					this.close();
				}

				show() {
					this.container.classList.remove('hidden');
				}

				get isShown() {
					return !this.container.classList.contains('hidden');
				}

				open() {
					this.show();

					this.book_buttons
						.forEach(button => button.classList.add('hidden'));
					this.back_buttons
						.forEach(button => button.classList.remove('hidden'));
				}

				close() {
					this.back_buttons
						.forEach(button => button.classList.add('hidden'));
					this.book_buttons
						.forEach(button => button.classList.remove('hidden'));
				}
			}
		);
	}

	static get all() {
		return this._all || (this._all = []);
	}

	constructor(container) {
		this.constructor.all.push(this);

		this.container = container;
		this.amount_block = this.container.querySelector('.amount');
		this.gateway_block = this.container.querySelector('.gateway');

		this.offers = Array.from(
			this.container
				.closest('.offers')
				.querySelectorAll(':scope > ul > li, :scope > section.offer')
		).map(offer => new this.constructor.Offer(offer));

		this.form = this.container;
		this.transportation_offer_id_input =
			this.form.querySelector('input[name="transportation_offer[id]"]');

		// Offers

		this.offers.forEach(offer => {
			offer.book_buttons.forEach(book_button => {
				book_button.addEventListener('click', () => {
					this.open(offer);
				});
			});

			offer.back_buttons.forEach(back_button => {
				back_button.addEventListener('click', () => {
					this.close();
					this.amount_block.removeChild(offer.amounts);
					this.gateway_block.removeChild(offer.gateways);
					this.gateway_block.removeChild(offer.pay_buttons);
				});
			});
		});

		// Open offer if its ID in query string

		const offer_id =
			new URLSearchParams(window.location.search)
				.get('transportation_offer_id');

		if (offer_id) {
			const offer = this.offers.find(offer => offer.id == offer_id);
			if (offer) this.open(offer);
		}
	}

	get selected_offer() {
		return Array.from(this.offers).find(offer => offer.isShown);
	}

	open(offer) {
		this.constructor.all.forEach(payment => payment.close());

		this.offers.forEach(offer2 => {
			offer2 == offer ? offer.open() : offer2.hide();
		});

		this.transportation_offer_id_input.value = offer.id;

		this.form.dataset.forAnalytics = JSON.stringify({
			price: offer.dataset.priceForAnalytics,
			currency: offer.dataset.currencyForAnalytics
		});

		this.amount_block.appendChild(offer.amounts);

		const refund_info_element =
			this.gateway_block.querySelector('.refund_info');
		this.gateway_block.insertBefore(offer.gateways, refund_info_element);
		this.gateway_block.insertBefore(offer.pay_buttons, refund_info_element);

		const first_gateway_input = this.gateway_block.querySelector('input');
		first_gateway_input.checked = true;
		first_gateway_input.dispatchEvent(new Event('change'));

		this.container.classList.remove('hidden');
	}

	close() {
		this.container.classList.add('hidden');

		this.offers.forEach(offer => {
			offer.close();
			offer.show();
		});

		this.transportation_offer_id_input.value = null;
		delete this.container.dataset.forAnalytics;
	}

	_pay_button_for(gateway) {
		return Array.from(this.pay_buttons)
			.find(button => button.dataset.for == gateway);
	}
}

export { Payment };
